type ParamsApp = {
    porpagina: number
}

const paramsApp: ParamsApp = {
    porpagina: 50
}

export default paramsApp